// until https://github.com/mui/material-ui/issues/44986 is fixed

if (typeof window !== "undefined") {
	window.matchMedia = globalThis.matchMedia.bind(window);
}
